export type CalculatorRecordScope = 'mine' | 'shared'

export interface CalculatorRecordOwnership {
  isMine?: boolean
}

export function partitionCalculatorRecords<T extends CalculatorRecordOwnership>(records: T[]) {
  const mine: T[] = []
  const shared: T[] = []
  for (const record of records) {
    if (record.isMine) mine.push(record)
    else shared.push(record)
  }
  return { mine, shared }
}
